// extracted by mini-css-extract-plugin
module.exports = {"broken-background":"ErrorPage_broken-background__lDLwv","root":"ErrorPage_root__Q4jjZ"};